import { useState } from 'react';
import DictionarySearchForm from '../components/dictionary/DictionarySearchForm';
import DictionaryResults from '../components/dictionary/DictionaryResults';
import AddToUserDictionaryModal from '../components/dictionary/AddToUserDictionaryModal';

export default function DictionaryPage() {
  const [searchText, setSearchText] = useState('');
  const [sourceLang, setSourceLang] = useState('eng');     // ← sensible default
  const [targetLang, setTargetLang] = useState('hin');     // ← sensible default
  const [domain, setDomain] = useState('all');             // ← or ''
  const [results, setResults] = useState([]);              // array of records
  const [loading, setLoading] = useState(false);           // ← added
  const [error, setError] = useState(null);                // ← added
  const [showAddModal, setShowAddModal] = useState(false);
  const [selectedEntryForAdd, setSelectedEntryForAdd] = useState(null);

  const handleSearch = async (searchParams) => {
    const { text, sourceLang, targetLang, domain } = searchParams;

    if (!text?.trim()) return;

    setLoading(true);
    setError(null);
    setResults([]);           // clear previous results

    const lang_pair = `${sourceLang}_${targetLang}`;

    try {
      const formData = new URLSearchParams();
      formData.append('user', 'sirfzahid007@gmail.com');
      formData.append('lang_pair', lang_pair);
      formData.append('custom_dict_list', 'system,rbiproject,user');
      formData.append('inputString', text.trim());
      formData.append('domain', domain || 'general');

      const response = await fetch(
        // Replace with your REAL endpoint
        'https://transzaar.ebslab.com/PostEditTool-Singleton-0.2.5.7/SearchRecordInParallelMTDicts',
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
          },
          body: formData.toString(),
        }
      );

      if (!response.ok) {
        throw new Error(`HTTP ${response.status} – ${response.statusText}`);
      }

      const data = await response.json();

      if (data.status !== 'SUCCESS') {
        throw new Error(data.message || 'API returned unsuccessful status');
      }

      // Important: use records array
      setResults(data.records || []);

    } catch (err) {
      console.error('Dictionary search failed:', err);
      setError(err.message || 'Failed to load results. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  const openAddModal = (entry) => {
    setSelectedEntryForAdd(entry);
    setShowAddModal(true);
  };

  return (
    <div className="min-h-screen bg-gray-50 pb-12">
      <main className="w-full mx-auto px-4 py-8">
        <DictionarySearchForm
          searchText={searchText}
          setSearchText={setSearchText}
          sourceLang={sourceLang}
          setSourceLang={setSourceLang}
          targetLang={targetLang}
          setTargetLang={setTargetLang}
          domain={domain}
          setDomain={setDomain}
          onSearch={handleSearch}
        />

        {loading && (
          <div className="mt-10 text-center">
            <div className="animate-spin rounded-full h-10 w-10 border-b-2 border-blue-600 mx-auto"></div>
            <p className="mt-4 text-gray-600">Searching...</p>
          </div>
        )}

        {error && (
          <div className="mt-8 bg-red-50 border border-red-200 text-red-700 px-5 py-4 rounded-lg">
            {error}
          </div>
        )}

        {!loading && !error && (
          <DictionaryResults
            results={results}
            searchText={searchText}
            onAddToDictionary={openAddModal}
          />
        )}
      </main>

      {showAddModal && selectedEntryForAdd && (
        <AddToUserDictionaryModal
          initialSource={selectedEntryForAdd.source}
          initialTarget={selectedEntryForAdd.target?.[0] || ''}
          onClose={() => setShowAddModal(false)}
        />
      )}
    </div>
  );
}